module.exports = __webpack_public_path__ + "static/img/9.0841925.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9.png
// module id = wsax
// module chunks = 0